import React, { useState, useRef, useEffect } from "react";
import { HiUsers } from "react-icons/hi2";
import useTenantSwitcher from "../Hooks/useTenantSwitcher";
import ConfirmModal from "./ConfirmModal";

// Only renders once availableTenants.length > 1 — a single-tenant user (the
// common case today) sees nothing, matching this feature's "invisible until
// relevant" requirement.
const TenantSwitcherMenu = () => {
  const {
    availableTenants,
    pendingTenant,
    showConfirmModal,
    isSwitching,
    initiateTenantSwitch,
    cancelTenantSwitch,
    confirmTenantSwitch,
  } = useTenantSwitcher();

  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  if (availableTenants.length <= 1) return null;

  return (
    <div className="relative" ref={menuRef}>
      <button
        type="button"
        onClick={() => setIsOpen((prev) => !prev)}
        className="flex items-center gap-2 py-2 px-3 rounded-md bg-canvas-primary text-canvas-white hover:brightness-110 transition-all"
      >
        <HiUsers className="w-5 h-5" />
        <span className="text-xs font-outfit font-semibold">Switch Tenant</span>
      </button>
      {isOpen && (
        <div className="absolute right-0 mt-2 w-48 bg-canvas-userbar rounded-lg shadow-lg border border-canvas-tersery z-50">
          {availableTenants.map((tenant) => (
            <button
              key={tenant.id}
              type="button"
              onClick={() => {
                setIsOpen(false);
                initiateTenantSwitch(tenant);
              }}
              className="w-full text-left px-4 py-2 text-sm text-canvas-black hover:bg-canvas-primary hover:text-canvas-white transition-colors font-outfit"
            >
              {tenant.name}
            </button>
          ))}
        </div>
      )}
      <ConfirmModal
        open={showConfirmModal}
        onClose={cancelTenantSwitch}
        onConfirm={confirmTenantSwitch}
        title="Switch tenant?"
        message={`Switch to ${pendingTenant?.name || "this account"}? You'll be redirected to the dashboard.`}
        confirmLabel={isSwitching ? "Switching..." : "Switch"}
        cancelLabel="Cancel"
      />
    </div>
  );
};

export default TenantSwitcherMenu;
